import React, { useCallback } from "react";
import { Dropdown } from "semantic-ui-react";

import _DeleteEmailModal from "routes/campaign/forms/DeleteEmailModal";
import withRoleCheck from "components/hocs/withRoleCheck";
import useAuthorized from "hooks/useAuthorized";
import ACL_RELATIONSHIPS from "acl-relationships";
import CampaignService from "services/Campaign";

const DeleteEmailModal = withRoleCheck(_DeleteEmailModal, [
  ACL_RELATIONSHIPS.email.delete,
]);

export function NoticeTableActionButtons({
  selectedIds = [],
  selectedData = [],
  uncheckAll,
  invalidateData,
  deleteNotices,
}) {
  const canSendEmail = useAuthorized([
    ACL_RELATIONSHIPS.campaignTargetEmail.create,
  ]);
  const disableActions = selectedData.length === 0;
  const disableResend = !canSendEmail;
  const onlyManuals = selectedData.every(email => email.is_manual === true);

  const handleDelete = useCallback(async () => {
    await deleteNotices(selectedIds);
    await invalidateData();
    uncheckAll();
  }, [selectedIds, uncheckAll, invalidateData, deleteNotices]);

  const handleResend = useCallback(async () => {
    const promises = [];
    for (const email of selectedData) {
      promises.push(
        CampaignService.sendEmail({
          campaignId: email.campaign_id,
          targetId: email.entity_id,
          contacts: [email.contact_id],
          template: email.template_id,
        })
      );
    }
    await Promise.all(promises);
    await invalidateData();
    uncheckAll();
  }, [selectedData, uncheckAll, invalidateData]);

  return (
    <Dropdown text="Actions" className="button mini" disabled={disableActions}>
      <Dropdown.Menu direction="left">
        <Dropdown.Item
          content="Resend"
          onClick={handleResend}
          disabled={disableResend}
        />
        <DeleteEmailModal
          onConfirmDelete={handleDelete}
          disabled={!onlyManuals}
          trigger={<Dropdown.Item content="Delete" />}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
}
